import { HttpClient, HttpHeaders, HttpParams, HttpParameterCodec } from "@angular/common/http";
import { EventEmitter, Injectable, Output } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, Observable } from "rxjs";
import { RetornoSelecao } from "../../../shared/gridview/RetornoSelecao";
import { environment } from "../../../../environments/environment";
import { ServiceCRUD } from "../../../shared/crud/ServiceCRUD";
import { ToastrService } from "ngx-toastr";



class CustomHttpParamEncoder implements HttpParameterCodec {
  encodeKey(key: string): string { return encodeURIComponent(key); }
  encodeValue(value: string): string { return encodeURIComponent(value); }
  decodeKey(key: string): string { return decodeURIComponent(key); }
  decodeValue(value: string): string { return decodeURIComponent(value); }
}

@Injectable()
export class RmpvDetalhadoService extends ServiceCRUD {
  private baseUrlService: string;
  carregando = true;

  private valorRecebido = new BehaviorSubject<any>(null);

  valorModal$ = this.valorRecebido.asObservable();

  @Output() exibir: EventEmitter<RetornoSelecao> =
    new EventEmitter<RetornoSelecao>();

  constructor(
    public httpClient: HttpClient,
    router: Router,
    protected toastr: ToastrService,
  ) {
    super(httpClient, router);
    this.baseUrlService = environment.URL_API;
  }

  httpOptions = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: JSON.parse(sessionStorage.getItem("currentUser")).token,
    }),
  };

  protected getURL(): string {
    return `${this.baseUrlService}/rmpv/detalhado`;
  }

  atualizarModal(event: any) {
    this.valorRecebido.next(event);
  }

  receberValorModal() {
    return this.valorRecebido.getValue();
  }

  /** Retorno completo dos dados (sem paginação na API); totais vêm no mesmo response. */
  public getDados(
    marcas?: any,
    data_inicial?: any,
    data_final?: any,
    dealer?: any,
    regiao?: any,
    mercado?: any,
    grupo_economico?: any,
    chassi?: any,
    placa?: any,
    numero?: any,
    nome_cliente?: any,
    documento_cliente?: any,
    status?: any,
    entregue?: any,
    blindado?: any,
    part_number?: any,
    dealers?: any,
    tipo_os?: any,
    modelo_veic?: any,
    andamento?: any,
  ): Observable<any> {
    return this.httpClient.get<any>(
      `${this.baseUrlService + "/rmpv/detalhado"}`,
      {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: JSON.parse(sessionStorage.getItem("currentUser"))
            .token,
        }),
        params: new HttpParams({ encoder: new CustomHttpParamEncoder() })
          .set("marcas", marcas.toString())
          .set("data_inicial", data_inicial ? data_inicial.toString() : "")
          .set("data_final", data_final ? data_final.toString() : "")
          .set("dealer", dealer.toString())
          .set("regiao", regiao.toString())
          .set("mercado", mercado.toString())
          .set("grupo_economico", grupo_economico.toString())
          .set("chassi", chassi.toString())
          .set("placa", placa.toString())
          .set("numero", numero.toString())
          .set("nome_cliente", nome_cliente.toString())
          .set("documento_cliente", documento_cliente.toString())
          .set("status", status.toString())
          .set("entregue", entregue.toString())
          .set("blindado", blindado === '' || blindado === null || blindado === undefined ? '' : blindado.toString())
          .set("part_number", part_number ? part_number.toString().trim() : "")
          .set("dealers", dealers.toString())
          .set("tipo_os", tipo_os.toString())
          .set("modelo_veic", modelo_veic != null && modelo_veic !== '' ? modelo_veic.toString().trim() : "")
          .set("andamento", andamento != null && andamento !== '' ? andamento.toString() : ""),

        },
    );
  }

  public getGenerico(endpoint: string, paramsObj: any = {}): Observable<any> {
    let params = new HttpParams();

    Object.keys(paramsObj).forEach((key) => {
      if (paramsObj[key] !== undefined && paramsObj[key] !== null) {
        params = params.set(key, paramsObj[key].toString());
      }
    });

    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization:
        JSON.parse(sessionStorage.getItem("currentUser"))?.token || "",
    });

    return this.httpClient.get<any>(`${this.baseUrlService}${endpoint}`, {
      headers,
      params,
    });
  }

  buscarFiltros(filtro: string): Observable<any> {
    return this.httpClient.get<any>(
      `${this.baseUrlService}/filtro/` + filtro,
      this.httpOptions,
    );
  }

  tratarErro(mensagem: string, titulo: string, error: any) {
    this.carregando = false;

    console.error(error);

    let texto: string;
    try {
      texto = error.erro ? mensagem + "\n" + error.erro : mensagem;
    } catch (Exception) {
      texto = mensagem;
    }

    this.toastr.error(texto, titulo, error);

    if (error.status === 401) {
      this.router.navigateByUrl("logout");
    }
  }

  public ver(registro: RetornoSelecao) {
    this.carregarModel(registro)
      .then((res) => {
        registro = res;
        this.exibir.emit(registro);
      })
      .catch((error) =>
        this.tratarErro("Não foi possível carregar o registro.", "Erro", error),
      );
  }

  protected carregarModel(registro: any): Promise<any> {
    return Promise.resolve(registro);
  }

  public exportPDF(id: any) {
    return this.httpClient.get(`${this.baseUrlService}/rmpv/OsExport/${id}`, {
      responseType: "text",
    });
  }

  public exportPDFosMontadora(
    numeroOs: number,
    idDealer: number,
    isFab: boolean,
  ) {
    return this.httpClient.get(
      `${this.baseUrlService}/rmpv/OsMontadoraExport`,
      {
        responseType: "text",
        params: {
          numeroOs: numeroOs.toString(),
          idDealer: idDealer.toString(),
          isFab: isFab.toString(),
        },

      },
    );
  }

  public exportAcompanhamento(
    numeroOs: number,
    idDealer: number,
    isFab: boolean,
  ) {
    return this.httpClient.get(
      `${this.baseUrlService}/rmpv/ExportAcompanhamento`,
      {
        responseType: "text",
        params: {
          numeroOs: numeroOs.toString(),
          IdDealer: idDealer.toString(),
          isFab: isFab.toString(),
        },
      },
    );
  }

public getFiltroMarcas(): Observable<any> {
  return this.httpClient.get<any>(
    `${environment.URL_API}/dash_filtro_marcas`,
    this.httpOptions
  );
}

}
